import { Actor, ActorSubclass, HttpAgent } from '@dfinity/agent'
import { idlFactory as cyclesMinterActor } from '../idls/cyclesMinter/cyclesMinter.did'
import type { _SERVICE as CyclesMinterActor } from '../idls/cyclesMinter/cyclesMinter.did'
import getAgent from '../utils/getAgent'
import { Principal } from '@dfinity/principal'
import { CYCLES_MINTER_CANISTER_ID } from '../constants/canisterIds'

class CyclesMinterClient {
  private helperActor: ActorSubclass<CyclesMinterActor>

  private static getActor(agent: HttpAgent) {
    return Actor.createActor(cyclesMinterActor, {
      canisterId: CYCLES_MINTER_CANISTER_ID,
      agent,
    }) as ActorSubclass<CyclesMinterActor>
  }

  constructor(agent: HttpAgent) {
    this.helperActor = CyclesMinterClient.getActor(agent)
  }

  static async getTCPerIcp() {
    const anonActor = CyclesMinterClient.getActor(getAgent())
    const conversionRate = await anonActor.get_icp_xdr_conversion_rate()
    return Number(conversionRate.data.xdr_permyriad_per_icp) * 10 ** -4
  }

  async notifyTopup(canisterId: string, block_index: bigint) {
    return this.helperActor.notify_top_up({
      block_index,
      canister_id: Principal.from(canisterId),
    })
  }

  async notifyMint(blockIndex: number) {
    return this.helperActor.notify_mint_cycles({
      block_index: BigInt(blockIndex),
      deposit_memo: [],
      to_subaccount: [],
    })
  }
}

export default CyclesMinterClient
